// import React, { useEffect } from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
// import { Table, Button, Row, Col } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import Message from '../components/Message';
// import Loader from '../components/Loader';
// import Paginate from '../components/Paginate';
// import {
//   listProducts,
//   deleteProduct,
//   createProduct,
//   resetCreateProduct,
// } from '../slices/productSlice';

// const ProductListScreen = ({ history, match }) => {
//   const dispatch = useDispatch();
//   const pageNumber = match.params.pageNumber || 1;

//   const {
//     loading,
//     error,
//     products,
//     page,
//     pages,
//     loadingDelete,
//     successDelete,
//     errorDelete,
//     loadingCreate,
//     successCreate,
//     errorCreate,
//     product,
//   } = useSelector((state) => state.productList);

//   const userInfo = useSelector((state) => state.user.userInfo);

//   useEffect(() => {
//     dispatch(resetCreateProduct());
//   }, [dispatch]);

//   useEffect(() => {
//     if (!userInfo || !userInfo.isAdmin) {
//       history.push('/login');
//       return;
//     }

//     if (successCreate) {
//       history.push(`/admin/product/${product._id}/edit`);
//     } else {
//       const adminCheck = userInfo.token;
//       dispatch(
//         listProducts({ keyword: '', sortBy: 'name', order: 'asc', adminCheck })
//       );
//     }
//   }, [dispatch, history, userInfo, successDelete, successCreate, product, pageNumber]);

//   const deleteHandler = (id) => {
//     if (window.confirm('Are you sure?')) {
//       dispatch(deleteProduct(id));
//     }
//   };

//   const createProductHandler = () => {
//     dispatch(createProduct());
//   };

//   return (
//     <>
//       <Row className='align-items-center'>
//         <Col>
//           <h1>Products</h1>
//         </Col>
//         <Col className='text-right'>
//           <Button className='my-3' onClick={createProductHandler}>
//             <i className='fas fa-plus'></i> Create Product
//           </Button>
//         </Col>
//       </Row>
//       {loadingDelete && <Loader />}
//       {errorDelete && <Message variant='danger'>{errorDelete}</Message>}
//       {loadingCreate && <Loader />}
//       {errorCreate && <Message variant='danger'>{errorCreate}</Message>}
//       {loading ? (
//         <Loader />
//       ) : error ? (
//         <Message variant='danger'>{error}</Message>
//       ) : (
//         <>
//           <Table responsive='md' striped hover size='sm' className='align-middle'>
//             <thead>
//               <tr>
//                 <th className='d-none d-md-table-cell'>ID</th>
//                 <th>Name</th>
//                 <th className='d-none d-sm-table-cell'>Price</th>
//                 <th className='text-center'>Buy</th>
//                 <th className='d-none d-lg-table-cell'>Category</th>
//                 <th className='d-none d-lg-table-cell'>Brand</th>
//                 <th className='text-end'>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {products.map((p) => (
//                 <tr key={p._id}>
//                   <td className='d-none d-md-table-cell small text-monospace'>{p._id}</td>

//                   <td>
//                     <div className='d-flex align-items-center' style={{ minWidth: 0 }}>
//                       <img
//                         src={p.image}
//                         alt={p.name}
//                         className='rounded me-2 d-none d-sm-inline'
//                         style={{ width: 40, height: 40, objectFit: 'cover' }}
//                       />
//                       <span className='text-truncate' style={{ maxWidth: 240 }}>{p.name}</span>
//                     </div>
//                   </td>

//                   <td className='text-center'>
//                     <Button
//                       as='a'
//                       href={p.purchaseLink}
//                       target='_blank'
//                       rel='noopener noreferrer'
//                       size='sm'
//                       variant='success'
//                     >
//                       <i className='fas fa-external-link-alt me-1' /> Buy
//                     </Button>
//                   </td>

//                   <td className='d-none d-sm-table-cell'>${Number(p.price || 0).toFixed(2)}</td>
//                   <td className='d-none d-lg-table-cell'>{p.category}</td>
//                   <td className='d-none d-lg-table-cell'>{p.brand}</td>

//                   <td className='text-end'>
//                     <div className='d-inline-flex gap-1'>
//                       <LinkContainer to={`/admin/product/${p._id}/edit`}>
//                         <Button variant='light' className='btn-sm'>
//                           <i className='fas fa-edit'></i>
//                         </Button>
//                       </LinkContainer>
//                       <Button
//                         variant='danger'
//                         className='btn-sm'
//                         onClick={() => deleteHandler(p._id)}
//                       >
//                         <i className='fas fa-trash'></i>
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//           <Paginate pages={pages} page={page} isAdmin={true} />
//         </>
//       )}
//     </>
//   );
// };

// export default ProductListScreen;




import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col, Modal, Form, Spinner, Alert, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import Paginate from '../components/Paginate';
import ProductTableFilters from '../components/ProductTableFilters';
import Meta from '../components/Meta';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
  listProducts,
  deleteProduct,
  createProduct,
  resetCreateProduct,
  bulkUpdateProductStatus,
} from '../slices/productSlice';

const ProductListScreen = ({ history, match }) => {
  const dispatch = useDispatch();
  const pageNumber = match.params.pageNumber || 1;
  // Viewport responsive state
  const [viewportWidth, setViewportWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const isMobile = viewportWidth <= 991; // expanded breakpoint: card mode for <=991px
  const isNarrow = viewportWidth <= 480;
  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const shortId = (id='') => (isMobile ? id.slice(-6) : id);

  const {
    loading,
    error,
    products,
    loadingDelete,
    successDelete,
    errorDelete,
    loadingCreate,
    successCreate,
    errorCreate,
    product,
  } = useSelector((state) => state.productList);

  const userInfo = useSelector((state) => state.user.userInfo);

  const [rawFilters, setRawFilters] = useState({ id:'', name:'', category:'', brand:'', priceMin:'', priceMax:'', status: '' });
  const [filters, setFilters] = useState(rawFilters);
  // Debounce rawFilters -> filters
  useEffect(() => {
    const t = setTimeout(() => setFilters(rawFilters), 300);
    return () => clearTimeout(t);
  }, [rawFilters]);
  const updateFilters = (patch) => setRawFilters((prev) => ({ ...prev, ...patch }));
  const clearFilters = () => { setRawFilters({ id:'', name:'', category:'', brand:'', priceMin:'', priceMax:'', status: '' }); };

  const normalizedFilters = {
    id: filters.id.trim().toLowerCase(),
    name: filters.name.trim().toLowerCase(),
    category: filters.category.trim().toLowerCase(),
    brand: filters.brand.trim().toLowerCase(),
    priceMin: filters.priceMin,
    priceMax: filters.priceMax,
    status: (filters.status || '').trim(),
  };
  const filteredProducts = products.filter(p => {
    if (normalizedFilters.id && !p._id.toLowerCase().includes(normalizedFilters.id)) return false;
    if (normalizedFilters.name && !p.name?.toLowerCase().includes(normalizedFilters.name)) return false;
    if (normalizedFilters.category && !(p.category||'').toLowerCase().includes(normalizedFilters.category)) return false;
    if (normalizedFilters.brand && !(p.brand||'').toLowerCase().includes(normalizedFilters.brand)) return false;
    if (normalizedFilters.priceMin && Number(p.price) < Number(normalizedFilters.priceMin)) return false;
    if (normalizedFilters.priceMax && Number(p.price) > Number(normalizedFilters.priceMax)) return false;
    if (normalizedFilters.status === 'enabled' && !!p.disabled) return false;
    if (normalizedFilters.status === 'disabled' && !p.disabled) return false;
    return true;
  });

  // Prioritize items named exactly "Sample name" before pagination
  const prioritizedProducts = [...filteredProducts].sort((a, b) => {
    const aIsSample = a?.name === 'Sample name';
    const bIsSample = b?.name === 'Sample name';
    if (aIsSample && !bIsSample) return -1;
    if (!aIsSample && bIsSample) return 1;
    return 0; // preserve existing relative order
  });

  // Client-side pagination (20 per page) driven by route param
  const PAGE_SIZE = 20;
  const routePage = Number(match.params.pageNumber || 1);
  const totalClientPages = Math.max(1, Math.ceil(prioritizedProducts.length / PAGE_SIZE));
  const currentPage = Math.min(Math.max(1, routePage), totalClientPages);
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const paginatedProducts = prioritizedProducts.slice(startIndex, startIndex + PAGE_SIZE);

  // AliExpress connect button state
  const [aeLoading, setAeLoading] = useState(false);
  const [aeError, setAeError] = useState(null);
  const [aeStatus, setAeStatus] = useState(null);
  // AI modal state
  const [showAiModal, setShowAiModal] = useState(false);
  const [modalProductId, setModalProductId] = useState('');
  const [modalLoading, setModalLoading] = useState(false);
  const [modalGenerated, setModalGenerated] = useState('');
  const [modalEditorState, setModalEditorState] = useState(EditorState.createEmpty());
  const [modalError, setModalError] = useState(null);
  const [modalPrompt, setModalPrompt] = useState('');

  useEffect(() => {
    dispatch(resetCreateProduct());
  }, [dispatch]);

  useEffect(() => {
    if (!userInfo || !userInfo.isAdmin) {
      history.push('/login');
      return;
    }

    if (successCreate) {
      history.push(`/admin/product/${product._id}/edit`);
    } else {
      const adminCheck = userInfo.token;
      dispatch(
        listProducts({ keyword: '', sortBy: 'name', order: 'asc', adminCheck, pageSize: 5000 })
      );
    }
    // `product` intentionally excluded below: it's only read inside the successCreate branch
    // (already gated by successCreate itself), and resetCreateProduct() sets a fresh {} reference
    // on every mount, which was causing an extra unnecessary refetch of the full product list
    // right after every mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history, userInfo, successDelete, successCreate, pageNumber]);

  useEffect(() => {
    if (!userInfo?.isAdmin) return;
    (async () => {
      try {
        const res = await fetch('/api/aliexpress/status', {
          headers: { Authorization: `Bearer ${userInfo?.token}` },
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok) setAeStatus(data);
      } catch {
        // Non-critical: leave aeStatus null, Connect AliExpress button still works
      }
    })();
  }, [userInfo]);

  const deleteHandler = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteProduct(id));
    }
  };

  const createProductHandler = () => {
    dispatch(createProduct());
  };

  const connectAliExpressHandler = async () => {
    setAeError(null);
    setAeLoading(true);
    try {
      const res = await fetch('/api/aliexpress/oauth/url', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo?.token}`,
        },
        credentials: 'include',
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.message || 'Failed to get AliExpress auth URL');
      }
      if (!data.authURL) {
        throw new Error('authURL missing in response');
      }
      window.location.href = data.authURL; // redirect to AliExpress authorization
    } catch (err) {
      setAeError(err.message || 'Unable to start AliExpress OAuth');
    } finally {
      setAeLoading(false);
    }
  };

  return (
    <>
  <Meta title='Admin — Products — The Lotustor' robots='noindex,follow' />
      <Row className='align-items-center'>
        <Col>
          <h1>Products</h1>
        </Col>
        <Col className='text-right'>
          <LinkContainer to='/admin/product/quick-import'>
            <Button variant='primary' className='my-3 me-2'>
              <i className='fas fa-bolt'></i> Quick Import
            </Button>
          </LinkContainer>
          <Button className='my-3' onClick={createProductHandler}>
            <i className='fas fa-plus'></i> Create Product
          </Button>
          {userInfo?.isAdmin && (
            <>
              <Button
                variant='outline-info'
                className='my-3 ms-2'
                onClick={() => {
                  setShowAiModal(true);
                  // default select first filtered product
                  setModalProductId(filteredProducts[0]?._id || '');
                  setModalGenerated('');
                  setModalEditorState(EditorState.createEmpty());
                  setModalPrompt('');
                  setModalError(null);
                }}
              >
                Generate / Edit AI Description
              </Button>
              <Button
                variant='outline-success'
                className='my-3 ms-2'
                onClick={async () => {
                  const targetIds = filteredProducts.map(p => p._id);
                  if (!targetIds.length) return;
                  const ok = window.confirm(`Enable all filtered products? (${targetIds.length})`);
                  if (!ok) return;
                  await dispatch(bulkUpdateProductStatus({ ids: targetIds, disabled: false }));
                  const adminCheck = userInfo.token;
                  dispatch(listProducts({ keyword: '', sortBy: 'name', order: 'asc', adminCheck, pageSize: 5000 }));
                }}
              >
                Enable All (Filtered)
              </Button>
              <Button
                variant='outline-warning'
                className='my-3 ms-2'
                onClick={async () => {
                  const targetIds = filteredProducts.map(p => p._id);
                  if (!targetIds.length) return;
                  const ok = window.confirm(`Disable all filtered products? (${targetIds.length})`);
                  if (!ok) return;
                  await dispatch(bulkUpdateProductStatus({ ids: targetIds, disabled: true }));
                  const adminCheck = userInfo.token;
                  dispatch(listProducts({ keyword: '', sortBy: 'name', order: 'asc', adminCheck, pageSize: 5000 }));
                }}
              >
                Disable All (Filtered)
              </Button>
            </>
          )}
          {userInfo?.isAdmin && (
            <LinkContainer to='/admin/categories'>
              <Button variant='outline-secondary' className='my-3 ms-2'>
                <i className='fas fa-sitemap me-1' /> Manage Categories
              </Button>
            </LinkContainer>
          )}
          {userInfo?.isAdmin && !aeStatus?.connected && (
            <Button
              variant='outline-primary'
              className='my-3 ms-2'
              onClick={connectAliExpressHandler}
              disabled={aeLoading}
            >
              {aeLoading ? 'Connecting…' : 'Connect AliExpress'}
            </Button>
          )}
          {userInfo?.isAdmin && aeStatus?.connected && !aeStatus?.lastError && (
            <Badge bg='success' className='ms-2 align-middle'>
              AliExpress connected
            </Badge>
          )}
          {userInfo?.isAdmin && aeStatus?.connected && aeStatus?.lastError && (
            <Alert variant='warning' className='mt-2 mb-0 d-flex align-items-center justify-content-between'>
              <span>AliExpress token refresh failed — reconnect to restore access.</span>
              <Button
                variant='outline-warning'
                size='sm'
                className='ms-3'
                onClick={connectAliExpressHandler}
                disabled={aeLoading}
              >
                {aeLoading ? 'Connecting…' : 'Reconnect AliExpress'}
              </Button>
            </Alert>
          )}
          <Modal show={showAiModal} onHide={() => setShowAiModal(false)} size='lg'>
            <Modal.Header closeButton>
              <Modal.Title>Generate / Edit AI Description</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {modalError && <Alert variant='danger'>{modalError}</Alert>}
              <Form.Group className='mb-2'>
                <Form.Label>Product</Form.Label>
                <Form.Control as='select' value={modalProductId} onChange={(e) => setModalProductId(e.target.value)}>
                  <option value=''>-- select product --</option>
                  {filteredProducts.map(p => (
                    <option key={p._id} value={p._id}>{p.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className='mb-2'>
                <Form.Label>Prompt (editable)</Form.Label>
                <Form.Control as='textarea' rows={4} value={modalPrompt} onChange={(e) => setModalPrompt(e.target.value)} placeholder='Optional prompt override' />
              </Form.Group>
              <div className='mb-3'>
                <Button variant='primary' onClick={async () => {
                  if (!modalProductId) return setModalError('Select a product')
                  setModalError(null)
                  setModalLoading(true)
                  try {
                    const prod = products.find(x => x._id === modalProductId)
                    const res = await fetch('/api/ai/generate-description', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo?.token}` },
                      body: JSON.stringify({ title: prod.name, images: [prod.image], context: modalPrompt })
                    })
                    const data = await res.json()
                    if (!res.ok) throw new Error(data.message || 'AI failed')
                    const html = data.description || ''
                    setModalGenerated(html)
                    try {
                      const { contentBlocks, entityMap } = htmlToDraft(html) || {}
                      setModalEditorState(
                        contentBlocks
                          ? EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap || {}))
                          : EditorState.createEmpty()
                      )
                    } catch {
                      setModalEditorState(EditorState.createEmpty())
                    }
                  } catch (err) {
                    setModalError(String(err.message || err))
                  } finally { setModalLoading(false) }
                }}>{modalLoading ? <><Spinner animation='border' size='sm' /> Generating...</> : 'Generate'}</Button>
              </div>
              <Form.Group>
                <Form.Label>Generated Description (edit before apply)</Form.Label>
                <Editor
                  editorState={modalEditorState}
                  onEditorStateChange={(editorState) => {
                    setModalEditorState(editorState)
                    setModalGenerated(draftToHtml(convertToRaw(editorState.getCurrentContent())) || '')
                  }}
                  toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
                  }}
                  wrapperClassName='border rounded'
                  editorClassName='px-2'
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={() => setShowAiModal(false)}>Close</Button>
              <Button variant='success' onClick={async () => {
                if (!modalProductId) return setModalError('Select a product')
                setModalError(null)
                setModalLoading(true)
                try {
                  const res = await fetch(`/api/products/${modalProductId}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo?.token}` },
                    body: JSON.stringify({ description: modalGenerated })
                  })
                  const data = await res.json()
                  if (!res.ok) throw new Error(data.message || 'Update failed')
                  // refresh product list
                  const adminCheck = userInfo.token
                  dispatch(listProducts({ keyword: '', sortBy: 'name', order: 'asc', adminCheck, pageSize: 5000 }))
                  setShowAiModal(false)
                } catch (err) {
                  setModalError(String(err.message || err))
                } finally { setModalLoading(false) }
              }}>Apply Description</Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
      {aeError && <Message variant='danger'>{aeError}</Message>}
      <ProductTableFilters filters={rawFilters} onChange={updateFilters} onClear={clearFilters} isMobile={isMobile} />
      <div className='small text-muted mb-2'>
        Showing {prioritizedProducts.length ? `${startIndex + 1}–${Math.min(startIndex + PAGE_SIZE, prioritizedProducts.length)}` : 0} of {prioritizedProducts.length} (Page {currentPage} of {totalClientPages})
      </div>
      {loadingDelete && <Loader />}
      {errorDelete && <Message variant='danger'>{errorDelete}</Message>}
      {loadingCreate && <Loader />}
      {errorCreate && <Message variant='danger'>{errorCreate}</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Table
            responsive
            striped
            hover
            size='sm'
            aria-label='Products list'
            className={`align-middle table-products ${isMobile ? 'mobile-mode' : ''}`}
          >
            {!isMobile && (
              <thead>
                <tr>
                  <th className='d-none d-md-table-cell'>ID</th>
                  <th>Name</th>
                  <th className='d-none d-sm-table-cell'>Price</th>
                  <th className='text-center'>Buy</th>
                  <th className='d-none d-lg-table-cell'>Category</th>
                  <th className='d-none d-lg-table-cell'>Brand</th>
                  <th className='d-none d-lg-table-cell'>Status</th>
                  <th className='text-end'>Actions</th>
                </tr>
              </thead>
            )}
            <tbody>
              {paginatedProducts.map((p) => {
                return (
                  <tr key={p._id}>
                    {!isMobile && (
                      <td data-label='ID' className='d-none d-md-table-cell small text-monospace'>
                        <Link to={`/product/${p._id}`} className='text-monospace text-decoration-none'>
                          {p._id}
                        </Link>
                      </td>
                    )}
                    <td data-label='Name'>
                      <div className='d-flex align-items-center w-100' style={{ minWidth: 0 }}>
                        <img
                          src={require('../utils/urlSanitizer').normalizeImageUrl(p.image)}
                          alt={p.name}
                          className={`rounded me-2 ${isMobile && isNarrow ? '' : 'd-none d-sm-inline'}`}
                          style={{ width: isMobile && isNarrow ? 32 : 40, height: isMobile && isNarrow ? 32 : 40, objectFit: 'cover' }}
                        />
                        <div className='flex-grow-1 min-w-0'>
                          <span className='text-truncate d-inline-block' style={{ maxWidth: 240 }}>{p.name}</span>
                          {p.disabled && (
                            <span className='badge bg-warning text-dark ms-2'>Disabled</span>
                          )}
                          {isMobile && (
                            <Link to={`/product/${p._id}`} className='text-muted small ms-2 text-decoration-none'>
                              #{shortId(p._id)}
                            </Link>
                          )}
                          {isMobile && isNarrow && (p.category || p.brand) && (
                            <small className='text-muted d-block mt-1'>
                              {(p.category || '') + (p.category && p.brand ? ' · ' : '') + (p.brand || '')}
                            </small>
                          )}
                        </div>
                      </div>
                    </td>
                    {!isNarrow && isMobile && (
                      <td data-label='Category'>{p.category}</td>
                    )}
                    {!isNarrow && isMobile && (
                      <td data-label='Brand'>{p.brand}</td>
                    )}
                    {isMobile && (
                      <td data-label='Status'>
                        <small className='text-muted'>Status: {p.disabled ? 'Disabled' : 'Enabled'}</small>
                      </td>
                    )}
                    <td data-label='Price' className={!isMobile ? 'd-none d-sm-table-cell' : ''}>
                      ${Number(p.price || 0).toFixed(2)}
                    </td>
                    <td data-label='Buy' className='text-center'>
                      <Button
                        as='a'
                        href={p.purchaseLink}
                        target='_blank'
                        rel='noopener noreferrer'
                        size='sm'
                        variant='success'
                      >
                        <i className='fas fa-external-link-alt me-1' /> Buy
                      </Button>
                    </td>
                    {!isMobile && (
                      <td data-label='Category' className='d-none d-lg-table-cell'>{p.category}</td>
                    )}
                    {!isMobile && (
                      <td data-label='Brand' className='d-none d-lg-table-cell'>{p.brand}</td>
                    )}
                    {!isMobile && (
                      <td data-label='Status' className='d-none d-lg-table-cell'>
                        {p.disabled ? (
                          <span className='badge bg-warning text-dark'>Disabled</span>
                        ) : (
                          <span className='badge bg-success'>Enabled</span>
                        )}
                      </td>
                    )}
                    <td data-label='Actions' className='text-end'>
                      <div className='d-inline-flex gap-1'>
                        <LinkContainer to={`/admin/product/${p._id}/edit`}>
                          <Button variant='light' className='btn-sm'>
                            <i className='fas fa-edit'></i>
                          </Button>
                        </LinkContainer>
                        <Button
                          variant='danger'
                          className='btn-sm'
                          onClick={() => deleteHandler(p._id)}
                        >
                          <i className='fas fa-trash'></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <Paginate pages={totalClientPages} page={currentPage} isAdmin={true} />
        </>
      )}
    </>
  );
};

export default ProductListScreen;
